import { IAuditLogsStore } from './types';

const initStore: IAuditLogsStore = {
  items: [],
  pagination: {
    page: 0,
    itemsPerPage: 20,
    hasMore: false,
  },
};

export default initStore;
